<template>
  <router-view />
</template>

<style lang="scss">
@import 'styles/style';

.center-pager {
  padding-top: 20px;
  display: flex;
  justify-content: center;
}

.footCard {
  border-radius: 0;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
}

.el-tabs__item {
  font-weight: 400;
  color: var(--el-text-color-secondary);
}

.el-tabs__item.is-active {
  font-weight: 700;
  color: var(--el-color-primary);
}

.el-scrollbar__bar.is-horizontal {
  height: 10px;
}

.el-scrollbar__bar.is-vertical {
  height: 10px;
}

.el-scrollbar__thumb {
  background-color: black;
}
</style>
